export default __webpack_public_path__ + "static/media/leaderboard-insight.56cbad8a.svg";